<div class="page-header">
	<div>
		<h1 class="page-title">Search Subscriber</h1>
		<div class="page-subtitle">By Document</div>
	</div>
</div>

<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Subscriber Document Search'"
			[downloadName]="'subscriber_document_search'"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="filters"
			[loading]="loading"
			(onRowClick)="open($event)"
			(onUpdateRequired)="doFetchResults($event)"
			[filterModal]="filterModal"
			[clickable]="canOpen">
			<ng-template #givenNames let-row="row">
				<td>
					{{row.document.firstName??''}} {{row.document.secondName??''}} {{row.document.otherNames??''}}
				</td>
			</ng-template>
			<ng-template #viewable let-row="row">
				<td *ngIf="row.hasAccess == true">
					View
				</td>
				<td *ngIf="row.hasAccess == false">
					-
				</td>
			</ng-template>
		</app-table>
	</div>
</div>





<ng-template #filterModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Subscriber Search</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body" [formGroup]="filterForm">


		<p>You can search for a subscriber using the following identifiers:</p>
		<div class="form-floating">
			<input type="text" id="documentNumber" class="form-control form-control-sm" placeholder="Enter Document Number" name="documentNumber" formControlName="documentNumber" [(ngModel)]="getFilter('documentNumber').value">
			<label for="documentNumber">Document Number</label>
		</div>
		<div class="row pt-1 pb-1">
			<div class="col text-center">
				<span class="text-secondary">OR</span>
			</div>
		</div>
		<div class="form-floating">
			<input type="text" id="idNumber" class="form-control form-control-sm" placeholder="Enter ID Number" name="idNumber" formControlName="idNumber" [(ngModel)]="getFilter('idNumber').value">
			<label for="idNumber">ID Number</label>
		</div>
		<div class="row pt-1 pb-1">
			<div class="col text-center">
				<span class="text-secondary">OR</span>
			</div>
		</div>
		<div class="input-group">
			<div class="form-floating">
				<input type="text" id="givenNames" class="form-control form-control-sm" placeholder="Enter Given Names" name="firstName" formControlName="firstName" [(ngModel)]="getFilter('firstName').value">
				<label for="givenNames">Given Names</label>
			</div>
			<span class="align-self-center px-2 text-secondary">AND</span>
			<div class="form-floating">
				<input type="text" id="lastName" class="form-control form-control-sm" placeholder="Enter Last Name" name="lastName" formControlName="lastName" [(ngModel)]="getFilter('lastName').value">
				<label for="lastName">Last Name</label>
			</div>
		</div>
		<hr/>
		<div class="row">
			<div class="col text-center">
				<span class="text-secondary">Additional Filters</span>
			</div>
		</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="issuingCountry">Issuing Country</label>
				<div class="col-sm-9">
					<input type="text" id="issuingCountry" class="form-control form-control-sm" placeholder="Issuing Country" name="issuingCountry" formControlName="issuingCountry" [(ngModel)]="getFilter('issuingCountry').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="nationality">Nationality</label>
				<div class="col-sm-9">
					<input type="text" id="nationality" class="form-control form-control-sm" placeholder="Nationality" name="nationality" formControlName="nationality" [(ngModel)]="getFilter('nationality').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="placeOfBirth">Place Of Birth</label>
				<div class="col-sm-9">
					<input type="text" id="placeOfBirth" class="form-control form-control-sm" placeholder="Place Of Birth" name="placeOfBirth" formControlName="placeOfBirth" [(ngModel)]="getFilter('placeOfBirth').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="subCountry">Sub Country</label>
				<div class="col-sm-9">
					<input type="text" id="subCountry" class="form-control form-control-sm" placeholder="Sub Country" name="subCountry" formControlName="subCountry" [(ngModel)]="getFilter('subCountry').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="division">Division</label>
				<div class="col-sm-9">
					<input type="text" id="division" class="form-control form-control-sm" placeholder="Division" name="division" formControlName="division" [(ngModel)]="getFilter('division').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="location">Location</label>
				<div class="col-sm-9">
					<input type="text" id="location" class="form-control form-control-sm" placeholder="Location" name="location" formControlName="location" [(ngModel)]="getFilter('location').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="dateOfBirth">Date Of Birth</label>
				<div class="col-sm-9">
					<input type="date" id="dateOfBirth" class="form-control form-control-sm" placeholder="Date Of Birth" name="dateOfBirth" formControlName="dateOfBirth" [(ngModel)]="getFilter('dateOfBirth').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="dateOfIssue">Date Of Issue</label>
				<div class="col-sm-9">
					<input type="date" id="dateOfIssue" class="form-control form-control-sm" placeholder="Date Of Issue" name="dateOfIssue" formControlName="dateOfIssue" [(ngModel)]="getFilter('dateOfIssue').value">
				</div>
			</div>
			<div class="row mb-1">
				<label class="col-sm-3 col-form-label" for="dateOfExpiry">Date Of Expiry</label>
				<div class="col-sm-9">
					<input type="date" id="dateOfExpiry" class="form-control form-control-sm" placeholder="Date Of Expiry" name="dateOfExpiry" formControlName="dateOfExpiry" [(ngModel)]="getFilter('dateOfExpiry').value">
				</div>
			</div>
		<p>This allows flexible and efficient lookup of subscriber or SIM information using industry-standard identifiers.</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="modal.close('Close click')">Search</button>
	</div>
</ng-template>
